import { NotificationAlertOverride } from ".";

export const BankingVerified: NotificationAlertOverride = () => ({
  theme: "success",
  icon: "check-circle"
});
